import { useEffect } from 'react'

/**
 * Submits on Enter pressed anywhere in the window, while `enabled`.
 *
 * Enter on a focused button is ignored: the browser already fires that button's click,
 * so handling it here too would submit twice.
 */
export const useSubmitOnEnterKey = (onSubmit: () => void, enabled: boolean) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!enabled || event.key !== 'Enter') return
      if (event.target instanceof HTMLButtonElement) return

      onSubmit()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [onSubmit, enabled])
}
